export const Field = ({ label, children, required = true, additionalLabelText = ''}) => (
  <div className="form-group">
    <label className="d-block">
      {label} {additionalLabelText && <em style={{color: '#828282'}}>
        ({additionalLabelText})
      </em>} {required && <span className="text-danger">*</span>}
    </label>
    {children}
  </div>
);